import { createRoot } from "react-dom/client"

import { Modal } from "@/components/Modal"
import { ThemeProvider } from "@/theme"

import { Button } from "../components/Button"
import { log } from "../utils"

export const showCacheUpdateModal = () => {
  const updateRoot = document.createElement("div")
  updateRoot.className = "default"
  document.body.appendChild(updateRoot)

  const root = createRoot(updateRoot)

  log("Showing service worker modal")

  root.render(
    <ThemeProvider>
      <Modal title="New updates are available" shouldShow>
        <p>Reload the page to see them.</p>
        <div className="mt-2xl flex">
          <Button
            onClick={() => window.location.reload()}
            variant="brand"
            size="lg"
          >
            Reload
          </Button>
          <Button
            onClick={() => {
              document.body.removeChild(updateRoot)
            }}
            variant="primary"
            size="lg"
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </ThemeProvider>,
  )
}
